<router-outlet>
</router-outlet>

<article class="spiner-container col-12" *ngIf="loadingService.getLoader() | async">
  <mat-spinner></mat-spinner>
</article>
